var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"VueTables__sort"},[(_vm.props.sortable)?_c('v-icon',[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }